import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { AppConfigService } from './app-config.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class HttpClientService {
  baseUrl: string;
  headers: HttpHeaders;

  constructor(private httpClient: HttpClient,
              private appConfigService: AppConfigService ) {
    this.baseUrl = this.appConfigService.api;
    const token = localStorage.getItem('token') || '';
    this.refreshHeaders(token);
  }

  refreshHeaders(token): void {
    this.headers = new HttpHeaders({
      //'Authorization': 'Bearer ' + token,
      //'local':'true',
      'Content-Type': 'application/x-www-form-urlencoded',
      // "ICAC_TICKET":'212731ED1D248CA0701B3F9561EAE90783B4AF0355E87FC838D8112E6956221ACA52A651C49A4EA8896734A360B4DB7F7F468E94B64742E08C353A4866BFB460AF46D3A810D56E694D1E0A3EBDB766E2F40F3C1F4AD716F69DCE0F76E9399D9038C7A9750C2BB93A4CD5E8A4A0011E2F'
      // "Cookie":'ICAC_TICKET=212731ED1D248CA0701B3F9561EAE907F8D71465CDF35457893EF2AAF0F94D9857E05528DD2B4526B72DFE61D8C9FDFE397268EBB91FC11CA359175D47B0072EC4F6BB4950EC3A4467B8A206835169077E4B4BE7F2F1A1D45846C21798AC0E14A09127B4277A76201A99A2F5967DE78A'
    });
  }

  setUrl(options: any): string {
    return options.fullUrl || this.baseUrl + options.url;
  }

  setHttpOptions(type: string, httpOptions: any): any {
    switch (type) {
      case 'text':
        httpOptions.responseType = 'text';
        break;
      case 'arraybuffer':
        httpOptions.responseType = 'arraybuffer';
        break;
      case 'blob':
        httpOptions.responseType = 'blob';
        break;
    }
    return httpOptions;
  }

  setParams(data: any): string {
    if (data === undefined) return '';
    let fromString = '';
    for (const key in data) {
      fromString += key + '=' + data[key] + '&';
    }
    return fromString.slice(0, -1);
  }

  getMethod(options: Options): Observable<any> {
    console.log('options', this.setUrl(options));
    const headers = this.headers;
    //options.withCredentials = true;
    const params = new HttpParams({
      fromString: this.setParams(options.data)
    });
    const httpOptions = !options.type ? {headers, params,withCredentials : true} : this.setHttpOptions(options.type, {headers, params, withCredentials : true});
    return this.httpClient.get(this.setUrl(options), httpOptions);
  }

  postMethod(options: Options): Observable<any> {
    const headers = this.headers;
    //options.withCredentials = true;
    const httpOptions = !options.type ? {headers,withCredentials : true} : this.setHttpOptions(options.type, {headers,withCredentials : true});
    return this.httpClient.post(this.setUrl(options), this.setParams(options.data),  httpOptions);
  }

  putMethod(options: Options): Observable<any> {
    const headers = this.headers;
    //options.withCredentials = true;
    const httpOptions = !options.type ? {headers, withCredentials : true} : this.setHttpOptions(options.type, {headers, withCredentials : true});
    return this.httpClient.put(this.setUrl(options), this.setParams(options.data), httpOptions);
  }
}

interface Options {
  data?: any;
  url?: string;
  type?: string;
  fullUrl?: string;
  withCredentials?: boolean;
}



// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/service/http-client.service.ts